import { computed as t, getCurrentInstance as l } from "vue";
import { debugWarn as a } from "./index588.js";
import i from "./index699.js";
const d = ["class", "style"], f = /^on[A-Z]/, v = (u = {}) => {
  const { excludeListeners: o = !1, excludeKeys: e } = u, c = t(() => (e?.value || []).concat(d)), r = l();
  return r ? t(
    () => {
      var n;
      return i(
        Object.entries((n = r.proxy) == null ? void 0 : n.$attrs).filter(
          ([s]) => !c.value.includes(s) && !(o && f.test(s))
        )
      );
    }
  ) : (a(
    "use-attrs",
    "getCurrentInstance() returned null. useAttrs() must be called at the top of a setup function"
  ), t(() => ({})));
};
export {
  v as useAttrs
};
